import React from "react";
import PdfListPage from "./PdfListPage";
import { useRoe } from "./RoeLayout";

export default function Notices() {
  const data = useRoe();
  return (
    <PdfListPage
      eyebrow="Communications"
      title="Notices & Circulars"
      accent="blue"
      items={data.notices_general || []}
      testid="roe-notices"
      emptyMsg="No notices or circulars have been published yet."
    />
  );
}
